var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonIconEyeMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.343,
    height: 43.666,
    viewBox: "0 0 45.343 43.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ButtonIcon_eye_mini",
    transform: "translate(0 0.778) rotate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1046",
    "data-name": "Tracciato 1046",
    d: "M12.476,0,.433,10.823,0,26.758l6.08,12.619,15.457,3.518,15.038-6.6L44.6,21.463,38.013,3.317,20.236.1Z",
    transform: "translate(0 0)",
    fill: "#826c9f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_631",
    "data-name": "Raggruppa 631",
    transform: "translate(7.818 13.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1044",
    "data-name": "Tracciato 1044",
    d: "M-668.824-3348.427l9.223-6.951,7.736-1.179,4.925,4.5,5.142,4.352-6.1,3.387-7.092,4.482-7.142-2.742Z",
    transform: "translate(668.824 3356.557)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1045",
    "data-name": "Tracciato 1045",
    d: "M-589.129-3350.044l-3.947,3.618,3.947,4.934,3.388-1.859,2.2-3.848Z",
    transform: "translate(601.371 3354.13)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconEyeMini);
export default __webpack_public_path__ + "static/media/ButtonIcon_eye_mini.5c66bd7978072a2df2d57fd3670a1b38.svg";
export { ForwardRef as ReactComponent };